import ManyObjectsWidgetSettings from './component'

export default ManyObjectsWidgetSettings
